import { Link } from "react-router-dom";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, waLink } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export function OwnerPhoto({ className = "" }) {
  return (
    <picture>
      <source type="image/webp" srcSet="/img/owner-640.webp 640w, /img/owner-1024.webp 1024w, /img/owner-1536.webp 1536w" sizes="(max-width:1024px) 100vw, 55vw" />
      <img src="/img/owner-1024.jpg" width="1536" height="1022" loading="lazy" decoding="async" alt="Lucky Choudhary, owner of Lucky Taxi Service, standing between two white Toyota Innova Crysta cabs beside the lake in Udaipur" className={className} />
    </picture>
  );
}

export function OwnerSection({ compact = false }) {
  return (
    <section className={compact ? "" : "container-x py-20 md:py-28"} aria-labelledby="owner-title" data-testid="owner-section">
      <Reveal className={`grid items-center gap-10 overflow-hidden rounded-[32px] border border-line bg-white ${compact ? "p-5 sm:p-7" : "p-5 sm:p-8 lg:grid-cols-12 lg:p-10"}`}>
        <div className={compact ? "" : "lg:col-span-7"}>
          <div className="relative overflow-hidden rounded-3xl">
            <OwnerPhoto className="aspect-[3/2] w-full object-cover" />
            <span className="absolute bottom-4 left-4 rounded-full bg-white/95 px-4 py-1.5 text-[13px] font-semibold text-ink">Lucky Choudhary · Owner</span>
          </div>
        </div>
        <div className={compact ? "" : "lg:col-span-5"}>
          <span className="eyebrow"><span className="h-px w-8 bg-gold" />Meet the owner</span>
          <h2 id="owner-title" className="mt-4 text-3xl font-semibold leading-tight sm:text-4xl">Lucky Choudhary, the person you speak to when you book.</h2>
          <p className="mt-4 text-[16px] leading-relaxed text-body">Lucky Taxi Service is run personally by Lucky Choudhary. When you call or WhatsApp, you deal directly with the owner, who plans your route, matches the right vehicle to your group and confirms the fare with you before the trip.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={`tel:${PHONE_TEL}`} className="btn-blue" data-testid="owner-call"><Phone className="h-4 w-4" aria-hidden />Call {PHONE_DISPLAY}</a>
            <a href={waLink("Hi Lucky ji, I want to book a taxi.")} target="_blank" rel="noopener noreferrer" className="btn-wa" data-testid="owner-whatsapp"><MessageCircle className="h-4 w-4" aria-hidden />WhatsApp</a>
            {!compact && <Link to="/about" className="btn-outline" data-testid="owner-about">About us</Link>}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
